import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IEntityVersion } from '../model/entity/EntityVersion';
import { IEntityVersionSearchParams } from '../api/requests/entities/entityVersionApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useEntitiesResult {
    isLoaded: boolean;
    entityVersions: IEntityVersion[];
}

export const useEntityVersions = (refreshToggle: boolean, searchParams: IEntityVersionSearchParams) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useEntitiesResult>({ isLoaded: false, entityVersions: [] });

    useEffect(() => {
        if (rootStore.categoryStore.currentCategory != null && rootStore.kindVersionStore.currentKindVersion != null) {
            setResult({ isLoaded: false, entityVersions: [] });

            rootStore.entityVersionStore.loadCurrentEntityVersionsForKindAndGameEnvironment(searchParams)
                .then(() => {
                    setResult({ isLoaded: true, entityVersions: rootStore.entityVersionStore.entityVersions });
                })
                .catch((e: any) => {
                    publishNotification({

                        text: `Error loading entities: ${e.message}`,
                        canClose: true
                    });
                });
        }
    }, [rootStore.categoryStore, rootStore.entityVersionStore, publishNotification, rootStore.gameEnvironmentsStore.currentGameEnvironment, rootStore.kindVersionStore.currentKindVersion, refreshToggle, searchParams]);

    return result;
};
